import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function ClosingStatement() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.2);
  return <section ref={ref} className={`w-full py-10 md:py-12 lg:py-16 px-6 md:px-12 lg:px-20 bg-white border-b border-gray-200 scroll-animate ${isVisible ? 'visible' : ''}`} data-id="element-38">
      <div className="max-w-[700px] mx-auto text-center" data-id="element-39">
        <h3 className="text-[20px] md:text-[24px] lg:text-[28px] font-bold text-brand-teal leading-[1.4] mb-6" data-id="element-40">
          Why This Matters (And Why Now)
        </h3>

        <div className="text-[16px] text-brand-navy font-normal leading-[1.8] space-y-4 text-left md:text-center" data-id="element-41">
          <p data-id="element-42">
            Understanding these six mechanisms explains why your child's skin
            <strong data-id="element-43"> hasn't improved despite your best efforts</strong>. It
            explains why expensive creams <strong data-id="element-44">disappoint</strong>. It
            explains why cheap filters didn't work. It explains why this problem
            feels <strong data-id="element-45">worse than it 'should be.'</strong>
          </p>
          <p data-id="element-46">
            But understanding the problem is step one. Step two is{' '}
            <strong data-id="element-47">addressing it at the source</strong>.
          </p>
          <p className="text-[#1B1B1B]" data-id="element-48">
            Most parents discover the difference between{' '}
            <strong data-id="element-49">treating symptoms</strong> and
            <strong data-id="element-50"> removing triggers</strong> only after months or years of
            the former. You now have the information they{' '}
            <strong data-id="element-51">wish they'd had earlier</strong>.
          </p>
        </div>
      </div>
    </section>;
}